import { BaseMaterialLocalModule } from './../_base/base-material-local.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFieldDirective } from './dynamic-field/dynamic-field.directive';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { C4dWebInputComponent } from './c4dweb-input/c4dweb-input.component';
import { C4dWebTextAreaComponent } from './c4dweb-textarea/c4dweb-textarea.component';
import { C4dWebCheckboxComponent } from './c4dweb-checkbox/c4dweb-checkbox.component';
import { C4dWebRadiobuttonComponent } from './c4dweb-radiobutton/c4dweb-radiobutton.component';
import { C4dWebSelectComponent } from './c4dweb-select/c4dweb-select.component';
import { C4dWebButtonComponent } from './c4dweb-button/c4dweb-button.component';
import { C4dWebDateComponent } from './c4dweb-date/c4dweb-date.component';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ChangeJustificationComponent } from './c4dweb-input/change-justification/change-justification.component';
import { PhdSoftWindowModule } from '@phdsoft/window';

@NgModule({
  declarations: [
    C4dWebInputComponent,
    C4dWebButtonComponent,
    C4dWebSelectComponent,
    C4dWebDateComponent,
    C4dWebRadiobuttonComponent,
    C4dWebCheckboxComponent,
    C4dWebTextAreaComponent,
    DynamicFieldDirective,
    DynamicFormComponent,
    ChangeJustificationComponent
  ],
  imports: [
    CommonModule,
    BaseMaterialLocalModule,
    ReactiveFormsModule,
    FormsModule,
    PhdSoftWindowModule
  ],
  exports: [
    C4dWebInputComponent,
    C4dWebButtonComponent,
    C4dWebSelectComponent,
    C4dWebDateComponent,
    C4dWebRadiobuttonComponent,
    C4dWebCheckboxComponent,
    C4dWebTextAreaComponent,
    DynamicFieldDirective,
    DynamicFormComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
]
})
export class BaseComponentCustomModule { }
